{
  "version": 1,
  "asset_id": "92380fda-2ab0-4fc5-bcbc-be159e9864e6",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/92380fda-2ab0-4fc5-bcbc-be159e9864e6/hiatal-type-3-story-hernia-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/92380fda-2ab0-4fc5-bcbc-be159e9864e6/hiatal-type-3-story-hernia-es-800.webp",
  "original_filename": "hiatal-type-3-story-hernia-es-800.webp",
  "size": 42854,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:22Z"
}
